import {createUseStyles} from 'react-jss';
import loadArtemisFonts from '../../v2/components/ui/loadArtemisFonts';
import isUsingArtemisStyles from '../../v2/selectors/isUsingArtemisStyles';
import MediaQueries from '../../v2/style-helper/MediaQueries';
import Typography from '../../v2/style-helper/Typography';

export default createUseStyles({
  completePage: {
    fontSize: props => props.theme.base.fontSize,
    lineHeight: '21px',
    padding: props => (props.isNewLFOrMyPGuest ? '1em 2em' : '1em'),
  },
  orderCompleteSection: {
    margin: 0,
  },
  nextStepComponents: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    
    [MediaQueries.phone]: {
      flexDirection: 'column',
    },
  },
  wrapper: {
    borderRight: '1px solid #ccc',
    justifyContent: 'center',
    alignItems: 'center',
    
    [MediaQueries.phone]: {
      boxShadow: 'none',
    },
  },
  isNewGuestUpdatedPageWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    paddingTop: 18,
    paddingBottom: 44,
    
    [MediaQueries.phone]: {
      flexDirection: 'column',
      paddingBottom: 0,
      borderRight: 'none',
    },
  },
  orderId: {
    fontSize: props => props.theme.base.fontSize,
    lineHeight: '21px',
    marginBottom: 25,
    textAlign: 'center',
    extend: props => ({
      ...(isUsingArtemisStyles && props.theme.typography?.[Typography.small])
      && loadArtemisFonts(props.theme.typography[Typography.small]),
    }),
    
    [MediaQueries.phone]: {
      marginBottom: 18,
    },
  },
  beautyHeader: {
    fontSize: 27,
    textAlign: 'center',
    fontWeight: 700,
    marginBottom: 6,
    lineHeight: 1.2,
    extend: props => ({
      ...(isUsingArtemisStyles && props.theme.typography?.[Typography.large1])
      && loadArtemisFonts(props.theme.typography[Typography.large1], true),
    }),
    
    [MediaQueries.phone]: {
      textAlign: 'left',
      marginTop: 20,
      marginBottom: 0,
      lineHeight: 'normal',
    },
  },
  caasOrderId: {
    fontSize: '24px',
    lineHeight: '21px',
    marginBottom: 60,
    textAlign: 'center',
    extend: props => ({
      ...(isUsingArtemisStyles && props.theme.typography?.[Typography.small])
      && loadArtemisFonts(props.theme.typography[Typography.small]),
    }),
    
    [MediaQueries.phone]: {
      marginBottom: 18,
    },
  },
});
